import { create } from 'zustand';

import { StageItem } from '@/types/stage.item.type';

export interface StageItemState {
  stageItems: Array<StageItem> | [];
  getStageItems: () => Array<StageItem> | [];
  setStageItems: (lists: Array<StageItem> | []) => void;
  // CUD Operations
  createStageItem: (item: StageItem) => void;
  updateStageItem: (id: string, item: StageItem) => void;
  deleteStageItem: (id: string) => void;
}

const useStageItemStore = create<StageItemState>((set, get) => ({
  stageItems: [],
  getStageItems: () => get().stageItems,
  setStageItems: (lists: Array<StageItem> | []) =>
    set(() => ({ stageItems: lists })),
  // CUD Operations
  createStageItem: (item: StageItem) =>
    set((state) => ({ stageItems: [...state.stageItems, item] })),
  updateStageItem: (id: string, newItem: StageItem) =>
    set((state) => ({
      stageItems: state.stageItems.map((item) =>
        item.id === id ? newItem : item
      ),
    })),
  deleteStageItem: (id: string) =>
    set((state) => ({
      stageItems: state.stageItems.filter((item) => item.id !== id),
    })),
}));

export { useStageItemStore };
